export let unitTransTokens: Array<any> = [
    'alertRulesTimeYears', 'alertRulesTimeMonths', 'alertRulesTimeWeeks', 'alertRulesTimeDays',
    'alertRulesTimeHours', 'alertRulesTimeMinutes', 'alertRulesTimeSeconds'
];

export let unitValues: Array<any> = ['years', 'months', 'weeks', 'days', 'hours', 'minutes', 'seconds'];